import { render, staticRenderFns } from "./eDateCard.vue?vue&type=template&id=54480abb&"
import script from "./eDateCard.vue?vue&type=script&lang=js&"
export * from "./eDateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports